import React from 'react'
import FrontendLayout from '../FrontendLayout'
import Hero from '../front-components/Hero'
import Services from '../front-components/Services'

export default function OurServices() {
  return (
    <FrontendLayout>
        <Hero title="Services" />
        <Services/>
    </FrontendLayout>
  )
}
